(function () {
    function initTrendingShowcase(section) {
        const wrapper = section.querySelector('.trending-slider-wrapper');
        if (!wrapper) return;

        const prevBtn = wrapper.querySelector('.trending-nav-btn.prev');
        const nextBtn = wrapper.querySelector('.trending-nav-btn.next');
        const track = wrapper.querySelector('.trending-slider-track');

        if (track) {
            function getStep() {
                const card = track.querySelector('.showcase-card');
                if (!card) return track.clientWidth * 0.8;
                const style = window.getComputedStyle(track);
                const gap = parseFloat(style.gap || style.columnGap || 0) || 24;
                return card.offsetWidth + gap;
            }

            function updateArrows() {
                const maxScroll = track.scrollWidth - track.clientWidth;
                if (maxScroll <= 5) {
                    if (prevBtn) prevBtn.style.display = 'none';
                    if (nextBtn) nextBtn.style.display = 'none';
                    return;
                }
                if (prevBtn) {
                    prevBtn.style.display = 'flex';
                    if (track.scrollLeft <= 5) {
                        prevBtn.classList.add('is-disabled');
                    } else {
                        prevBtn.classList.remove('is-disabled');
                    }
                }
                if (nextBtn) {
                    nextBtn.style.display = 'flex';
                    if (track.scrollLeft >= maxScroll - 5) {
                        nextBtn.classList.add('is-disabled');
                    } else {
                        nextBtn.classList.remove('is-disabled');
                    }
                }
            }

            let targetScroll = null;
            let scrollTimer = null;

            function scrollSlider(dir) {
                const step = getStep();
                const maxScroll = track.scrollWidth - track.clientWidth;
                if (targetScroll === null || Math.abs(track.scrollLeft - targetScroll) > step * 1.5) {
                    targetScroll = track.scrollLeft;
                }
                if (dir === 'next') {
                    targetScroll = Math.min(maxScroll, targetScroll + step);
                } else {
                    targetScroll = Math.max(0, targetScroll - step);
                }
                track.scrollTo({ left: targetScroll, behavior: 'smooth' });
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(() => {
                    targetScroll = null;
                    updateArrows();
                }, 350);
            }

            if (prevBtn) {
                prevBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    scrollSlider('prev');
                });
            }

            if (nextBtn) {
                nextBtn.addEventListener('click', (e) => {
                    e.preventDefault();
                    scrollSlider('next');
                });
            }

            track.addEventListener('scroll', updateArrows, { passive: true });
            window.addEventListener('resize', updateArrows);
            updateArrows();

            // Drag to scroll on desktop without snapping friction
            let isDown = false;
            let startX = 0;
            let scrollStart = 0;
            let hasDragged = false;
            const DRAG_THRESHOLD = 10;

            track.addEventListener('dragstart', (e) => {
                e.preventDefault();
            });

            track.addEventListener('mousedown', (e) => {
                if (e.button !== 0) return;
                isDown = true;
                hasDragged = false;
                targetScroll = null;
                startX = e.pageX;
                scrollStart = track.scrollLeft;
            });

            window.addEventListener('mousemove', (e) => {
                if (!isDown) return;
                const deltaX = e.pageX - startX;
                if (Math.abs(deltaX) > DRAG_THRESHOLD) {
                    if (!hasDragged) {
                        hasDragged = true;
                        track.classList.add('active-drag');
                        track.style.scrollSnapType = 'none';
                        track.style.scrollBehavior = 'auto';
                    }
                    track.scrollLeft = scrollStart - deltaX;
                }
            });

            window.addEventListener('mouseup', () => {
                if (!isDown) return;
                isDown = false;
                if (hasDragged) {
                    track.classList.remove('active-drag');
                    track.style.scrollSnapType = '';
                    track.style.scrollBehavior = '';
                    updateArrows();
                    setTimeout(() => {
                        hasDragged = false;
                    }, 80);
                }
            });

            track.addEventListener(
                'click',
                (e) => {
                    if (hasDragged) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                },
                true
            );
        }
    }

    document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('.trending-showcase-section').forEach(initTrendingShowcase);
    });

    if (window.Shopify && Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => {
            if (e.target.classList.contains('trending-showcase-section')) {
                initTrendingShowcase(e.target);
            }
        });
    }
})();